import { DataFlowSource } from 'app/model/dataflow/dataflow-source';
import { LinkedService, Dataset } from 'shell-models-lib';
import { IMapperConnectionInfo, IMapperTable } from 'app/model/adfDataMapper/IMapperTable';
import { DataFlowDatasetSettings, DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { QueryApiFactoryService } from 'app/apis/query-api.factory.service';
import { DslConnectorConstants } from 'app/model/adapters/mappingArtifact/DslConnectorConstants';
import { Subject } from 'rxjs';
import { LoggerService } from 'app/logger/logger.service';

export abstract class DatasetTypeHandler {

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public abstract getOkButtonStatus(selectedRows: any[], isTargetPanel?: boolean): [boolean, string];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public abstract processSelectedRows(selectedRows: any[],
        selectedSourceLinkedService: LinkedService,
        selectedDatesetFormat: DatasetFormatType,
        selectedSourceFileOptions?: DataFlowDatasetSettings): IMapperTable[];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public abstract populateSourceProperties(inputSource: DataFlowSource, outputSource: DataFlowSource, selectedDatasetFormat: DatasetFormatType): any;

    public abstract getDatasetSettings(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        dslConnectorProperties: Map<string, any>,
        table: IMapperTable): DataFlowDatasetSettings;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public abstract getDatasetForPreview(dslConnectorProperties: Map<string, any>, linkedService: LinkedService): Dataset;

    public abstract setCommonDslConnectionProperties(mapperConnectionInfo: IMapperConnectionInfo, selectedDatasetFormat: DatasetFormatType, selectedSourceFileOptions?: DataFlowDatasetSettings): void;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public async fetchEntities(loggerService: LoggerService, queryApiFactoryService: QueryApiFactoryService, linkedService: LinkedService,
        isSource?: boolean, _selectedDatasetFormat?: DatasetFormatType, isDebugSessionActive: () => Promise<boolean> = undefined,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        getEntitiesForADataFlowSource: (dataflowSource: DataFlowSource, resultSubject: Subject<any>) => Promise<void> = undefined): Promise<any[]> {
            const fileFormatType = [DatasetFormatType.Avro, DatasetFormatType.Delimited, DatasetFormatType.Json, DatasetFormatType.Orc, DatasetFormatType.Parquet, DatasetFormatType.Orc, DatasetFormatType.Xml];
            if(!isSource && !fileFormatType.includes(_selectedDatasetFormat)) {
                return await queryApiFactoryService.getWizardQueryApi().getNavTableAsync(linkedService);
            }
            return [''];
    }

    public updateMapperTablePropertiesOnEdit(existingMapperTable: IMapperTable, updatedMapperTable: IMapperTable): void { }

    public doReImportSchemaforEditOption(existingMapperTable: IMapperTable, updatedMapperTable: IMapperTable): boolean {
        return false;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public getFileOptions(): any {
        return {
            compressionTypeOptions: [],
            encodingOptions: []
        };
    }

    public getDefaultFileSettings(): DataFlowDatasetSettings {
        return undefined;
    }


    protected setCommonDslDriftProperties(mapperConnectionInfo: IMapperConnectionInfo): void {
        if (!!mapperConnectionInfo && !!mapperConnectionInfo.tables) {
            const commonDslConnectorProperties = mapperConnectionInfo.connection.commonDslConnectorProperties;
            commonDslConnectorProperties.set(DslConnectorConstants.allowSchemaDrift, true);
            commonDslConnectorProperties.set(DslConnectorConstants.inferDriftedColumnTypes, true);

            // enable schema drift by default for all tables
            mapperConnectionInfo.tables.forEach((table) => {
                // only turn it on for newly added tables (handling edit mode)
                if (table.isSchemaDrifted === undefined) {
                    table.isSchemaDrifted = true;
                }
            });
        }
    }
}
